import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';
import { rgba } from 'polished';

import * as graphql from 'generated/graphql';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';
import ArrowRightAboveIcon from 'packages/kakapo-ui-kit/assets/icons/ArrowRightAboveIcon';

import Color from '../../common/Color';
import PopoverTarget from '../../popovers/PopoverTarget';
import Paragraph from '../../common/Paragraph';
import QuillText from '../../editors/QuillText';

const Container = styled(Box)<{ unspaced?: boolean }>`
	background: ${(props) => (props.unspaced ? 'white' : props.theme.colors.whiteBlueLight)};
	border-radius: 4px;
	border: 1px solid ${(props) => props.theme.colors.lightBlue};
	border-radius: 4px;
	box-shadow: 0 2px 4px ${(props) => rgba(props.theme.colors.lightBlue, 0.5)};
`;

const TooltipTitle = styled.div`
	border-top: 1px solid ${(props) => props.theme.colors.lightBlue};
	padding-top: 10px;
	margin: 0px -20px;
	margin-top: 10px !important;
	margin-bottom: -5px;
	text-align: center;
`;

export default function GoalListItemCompetency(props: {
	competency: graphql.CompetencyGoal;
	unspaced?: boolean;
}) {
	const { t } = useTranslation();
	const { localize } = useLocalize();

	const option = props.competency.competency.levels[props.competency.competencyLevelIndex];

	return (
		<Container unspaced={props.unspaced} p={3}>
			<Box mb={2}>
				<Color color="slateBlue">{t('goals.list.attachedCompetency')}</Color>
			</Box>
			<Flex justifyContent="space-between">
				<Box fontWeight="bold">
					<Color color="antracite">{localize(props.competency.competency.title).text}</Color>
				</Box>
				<PopoverTarget
					content={
						<Box style={{ padding: 20 }}>
							<Paragraph color="slateBlue">
								<QuillText
									quill={localize(option.criteria ?? [])?.text}
									placeholder={t('evaluation.submission.competency.levels.noDescription')}
								/>
							</Paragraph>
							<TooltipTitle>{localize(option.level.title).text}</TooltipTitle>
						</Box>
					}
				>
					<Flex alignItems="center">
						<Box flexGrow={0} flexShrink={0} mr={2}>
							<ArrowRightAboveIcon color="antracite" />
						</Box>
						<Box flexGrow={0} flexShrink={0}>
							<Color color="antracite">{localize(option.level.title).text}</Color>
						</Box>
					</Flex>
				</PopoverTarget>
			</Flex>
		</Container>
	);
}
